module.exports = __webpack_public_path__ + "img/page-01.e0d7c441.jpg";